export { default as logger } from './logger';

export * from './auth0Token';
export * from './chipLabels';
export * from './dateFieldSections';
export * from './dates';
export * from './formatting';
export * from './objectUtils';
export * from './rocketUrls';
export * from './searchTreePlaceholders';
export * from './tree';
export * from './userLevel';

export function delay(millis: number) {
  return new Promise((resolve) => setTimeout(resolve, millis));
}

export function noop() {}

export const toggleExpansion = (expansionState: boolean[], index: number) => {
  const finalExpansionState = Array(expansionState.length);
  for (let i = 0; i < expansionState.length; i++) {
    if (i === index) {
      finalExpansionState[i] = !expansionState[i];
    } else {
      finalExpansionState[i] = expansionState[i];
    }
  }
  return finalExpansionState;
};

export const adjustPageNo = (oldPageSize: number, oldPageNo: number, newPageSize: number) => {
  if (oldPageSize === 0) {
    return 0;
  }
  return Math.floor((oldPageSize * oldPageNo) / newPageSize);
};

export const randomStringFromList = (strs: string[]) =>
  strs[Math.floor(Math.random() * strs.length)];
